import {
  FETCH_FOOTER_DETAILS_BEGIN,
  FETCH_FOOTER_DETAILS_SUCCESS,
  FETCH_FOOTER_DETAILS_FAILURE,
  RESET_FOOTER_DETAILS
} from '../constants/footerActionTypes';

const initialState = {
  FooterInfo: {
    details: []
  },
  isFetching: false,
  contentLoaded: false,
  isLoading: true,
  error: {},
}

export default function (state, action) {
  if (typeof state === 'undefined') {
    state = initialState;
  }
  switch (action.type) {
    case FETCH_FOOTER_DETAILS_BEGIN:
      return {
        ...state,
        isFetching: true,
        isLoading: true,
      };
    case FETCH_FOOTER_DETAILS_SUCCESS:
      return {
        ...state,
        FooterInfo: action.payload,
        isFetching: false,
        contentLoaded: true,
        isLoading: false,
        error: null
      };
    case FETCH_FOOTER_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
        contentLoaded: true,
        isLoading: false
      };
      case RESET_FOOTER_DETAILS:
      return {
        ...state,
        FooterInfo: [],
        isFetching: false,
        contentLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
}
